/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Integrations_DescInputs */

const en_options_integrations_desc = /** @type {(inputs: Options_Integrations_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connect to third-party services for enhanced functionality`)
};

const fr_options_integrations_desc = /** @type {(inputs: Options_Integrations_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connectez des services tiers pour des fonctionnalités avancées`)
};

const de_options_integrations_desc = /** @type {(inputs: Options_Integrations_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verbinden Sie sich mit Diensten von Drittanbietern, um die Funktionalität zu erweitern.`)
};

const it_options_integrations_desc = /** @type {(inputs: Options_Integrations_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connettiti a servizi di terze parti per funzionalità avanzate`)
};

const ru_options_integrations_desc = /** @type {(inputs: Options_Integrations_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подключайтесь к сторонним сервисам для расширения функциональности.`)
};

const es_options_integrations_desc = /** @type {(inputs: Options_Integrations_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conéctese a servicios de terceros para obtener una funcionalidad mejorada`)
};

const zh_cn2_options_integrations_desc = /** @type {(inputs: Options_Integrations_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`连接第三方服务以增强功能`)
};

const ja_options_integrations_desc = /** @type {(inputs: Options_Integrations_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サードパーティのサービスに接続して機能を強化する`)
};

const hi_options_integrations_desc = /** @type {(inputs: Options_Integrations_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बेहतर कार्यक्षमता के लिए तृतीय-पक्ष सेवाओं से जुड़ें`)
};

const pt_pt2_options_integrations_desc = /** @type {(inputs: Options_Integrations_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conecte-se a serviços de terceiros para obter funcionalidades aprimoradas.`)
};

/**
* | output |
* | --- |
* | "Connect to third-party services for enhanced functionality" |
*
* @param {Options_Integrations_DescInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_integrations_desc = /** @type {((inputs?: Options_Integrations_DescInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Integrations_DescInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_integrations_desc(inputs)
	if (locale === "de") return de_options_integrations_desc(inputs)
	if (locale === "it") return it_options_integrations_desc(inputs)
	if (locale === "ru") return ru_options_integrations_desc(inputs)
	if (locale === "es") return es_options_integrations_desc(inputs)
	if (locale === "zh-CN") return zh_cn2_options_integrations_desc(inputs)
	if (locale === "ja") return ja_options_integrations_desc(inputs)
	if (locale === "hi") return hi_options_integrations_desc(inputs)
	if (locale === "pt-PT") return pt_pt2_options_integrations_desc(inputs)
	return en_options_integrations_desc(inputs)
});